import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { frontendDb as db } from '../lib/frontend-db';
import BieberHeader from './BieberHeader';
import BieberFooter from './BieberFooter';

const BieberPrivacy = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    loadPrivacy();
  }, []);

  const loadPrivacy = async () => {
    try {
      const settings = await db.getSettings();
      if (settings) {
        const privacyContent = (settings as any).bieber_privacy_content || 'Bitte geben Sie hier Ihre Datenschutzerklärung ein.';
        setContent(privacyContent);
      }
    } catch (error) {
      console.error('Error loading privacy:', error);
      setError('Fehler beim Laden der Datenschutzerklärung. Bitte versuchen Sie es später erneut.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen transition-colors duration-300" style={{ backgroundColor: 'var(--bg-primary)' }}>
        <BieberHeader />
        <div className="container mx-auto px-4 py-16 mt-16">
          <div className="space-y-4">
            <div className="h-8 rounded w-1/3 animate-pulse" style={{ backgroundColor: 'var(--bg-secondary)' }} />
            <div className="space-y-2">
              <div className="h-4 rounded animate-pulse" style={{ backgroundColor: 'var(--bg-secondary)' }} />
              <div className="h-4 rounded w-5/6 animate-pulse" style={{ backgroundColor: 'var(--bg-secondary)' }} />
            </div>
          </div>
        </div>
        <BieberFooter />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen transition-colors duration-300" style={{ backgroundColor: 'var(--bg-primary)' }}>
        <BieberHeader />
        <div className="container mx-auto px-4 py-16 mt-16">
          <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-6 text-center">
            <h2 className="text-xl font-semibold text-red-800 mb-2">Fehler</h2>
            <p className="text-red-600 dark:text-red-400">{error}</p>
          </div>
        </div>
        <BieberFooter />
      </div>
    );
  }

  return (
    <div className="min-h-screen transition-colors duration-300" style={{ backgroundColor: 'var(--bg-primary)' }}>
      <BieberHeader />
      <main className="container mx-auto px-4 py-16 mt-16">
        <div className="max-w-4xl mx-auto">
          <div className="mb-8">
            <Link
              to="/bieber-info"
              className="inline-flex items-center text-sm transition-colors duration-200 hover:opacity-80"
              style={{ color: 'var(--text-primary)' }}
            >
              ← Zurück zu Liederkranz Bieber
            </Link>
          </div>
          
          <div className="prose prose-lg mx-auto">
            <h1 className="text-3xl font-bold mb-8" style={{ color: 'var(--text-primary)' }}>
              Datenschutzerklärung
            </h1>
            <div 
              className="whitespace-pre-line leading-relaxed"
              style={{ color: 'var(--text-primary)' }}
            >
              {content}
            </div>
          </div>
        </div>
      </main>
      <BieberFooter />
    </div>
  );
};

export default BieberPrivacy; 

